import IPFModel from '../models/ipf.model';

let storeContent = utils.generateStore({
	clientQuotations: [],
	selectedClientQuote: null,
	selectedClientRecommendation: null,
	selectedClientQuoteSummary: null,
	showQuotationModal: false,
	activeTab: 1,
	currentPage: 1,
	quotationSource: null,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		//   openTab(ctx,page){
		//      ctx.commit('activeTab',page)
		//   },
		async acceptClientQuote(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'quotation',
						action: 'accept',
						data: {
							client_quotation_id:
								ctx.getters.selectedQuote.client_quotation_id,
						},
					},
					'/client',
				);

				ctx.commit('loading', false);
				//ctx.commit('currentPage', 2)
				ctx.commit('quotationSource', payload);
				ctx.commit(
					'quotationID',
					ctx.getters.selectedQuote.client_quotation_id,
				);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async declineClientQuote(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'quotation',
						action: 'reject',
						data: {
							client_quotation_id:
								ctx.getters.selectedQuote.client_quotation_id,
						},
					},
					'/client',
				);

				ctx.commit('loading', false);
				$notify(
					'success',
					'Quote Declined',
					`Claim for project ${ctx.getters.selectedQuote.product_details.product_name} declined`,
					10,
				);
				//ctx.commit('showQuotationModal', false)
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async initialize(ctx, payload) {
			try {
				await ctx.dispatch('fetchQuotations');
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
		async fetchClientQuotations(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'quotation',
						action: 'list',
						data: {},
					},
					'/client',
				);

				ctx.commit('quotations', res.result.quotations);
			} catch (err) {
				throw err;
			}
		},
		async viewClientQuote(ctx, payload) {
			console.log('viewing client quote');
			try {
				Event.$emit('loader:show', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'quotation',
						action: 'get_guest_client_quotation',
						data: {
							//   guest_client_quotation_system_ref: payload.quote.guest_client_quotation_system_ref
							guest_client_quotation_system_ref:
								payload.quotationID,
						},
					},
					'/client',
				);

				console.log('client quote ====', res);

				ctx.commit('selectedClientQuote', res.result[0]);
				ctx.commit('showQuotationModal', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
		async viewClientQuoteRecommendation(ctx, payload) {
			try {
				Event.$emit('loader:show', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'quotation',
						action: 'get_guest_client_recommendation',
						data: {
							//   guest_client_quotation_system_ref: payload.quote.guest_client_quotation_system_ref
							guest_client_quotation_recommendation_ref:
								payload.guest_client_quotation_recommendation_ref,
						},
					},
					'/client',
				);

				console.log('client recommenda ====', res);

				ctx.commit('selectedClientRecommendation', res.result);
				ctx.commit('showQuotationModal', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},

		async updateGuestRecommendationBenefit(ctx, payload) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'quotation',
						action: 'update_guest_recommendation_benefit',
						data: {
							free_limit: payload.free_limit,
							product_benefit_id: payload.product_benefit_id,
							guest_client_recommendation_id:
								payload.guest_client_recommendation_id,
						},
					},
					'/client',
				);

				console.log('updated recommendation benefit ====', res);

				//ctx.commit('selectedClientRecommendation', res.result);
				ctx.commit('showQuotationModal', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},

		async viewClientQuoteSummary(ctx, payload) {
			console.log('calling client quote summary', payload);
			try {
				Event.$emit('loader:show', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'quotation',
						action: 'get_guest_client_quotation_details',
						data: {
							system_quotation_ref: payload.system_quotation_ref,
						},
					},
					'/client',
				);

				console.log('client quote summ ====', res);
				ctx.commit(
					'selectedClientQuoteSummary',
					res.result.quotation_details_summary,
				);
				ctx.commit('showQuotationModal', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async createInvoice(ctx, payload) {
			try {
				// Extract form data from payload
				const formData = payload.policyFormref.formData_ || {};
				const response = await api.fetchEndpointSecure(
					{
						resource: 'quotation',
						action: 'purchase_quotation',
						data: {
							system_quotation_ref: formData.system_quotation_ref, // Use getter for quotationID
							tnc: formData.terms,
							special_code: formData.discountCode || '',
							cover_start_date: formData.startDate,
							tnc_type: formData.termsDownload || 'default',
							krapin: formData.krapin,
							id_no: formData.idNo,
						},
					},
					'/client',
				);
				// Optionally dispatch fetchQuotationDetails if needed
				// await ctx.dispatch('fetchQuotationDetails');
				return response; // Return response for component handling
			} catch (err) {
				console.error('Error creating invoice:', err);
				throw new Error('Failed to create invoice');
			}
		},
	},
};
